import { NgModule } from '@angular/core';
import { WorkspaceTreeDirective } from './workspace-tree.directive';

@NgModule({
  declarations: [WorkspaceTreeDirective],
  exports: [WorkspaceTreeDirective]
})
export class WorkspaceTreeModule { }
